<template>
    <div>
        <div>
            <div class="col-11 text-right menu-locale">
                <base-button
                    size="sm"
                    type="primary"
                    v-if="this.$i18n.locale == 'en'"
                    @click="en()"
                    >EN</base-button
                >
                <base-button
                    size="sm"
                    type="neutral"
                    v-if="this.$i18n.locale == 'th'"
                    @click="en()"
                    >EN</base-button
                >
                <base-button
                    size="sm"
                    type="primary"
                    v-if="this.$i18n.locale == 'th'"
                    @click="th()"
                    >TH</base-button
                >
                <base-button
                    size="sm"
                    type="neutral"
                    v-if="this.$i18n.locale == 'en'"
                    @click="th()"
                    >TH</base-button
                >
            </div>
        </div>
        <!-- Header -->
        <div class="header  py-7 py-lg-6 pt-lg-1">
            <div class="container">
                <div class="header-body text-center mb-7">
                    <div class="row justify-content-center">
                        <div class="col-md-8 px-5">
                            <!-- <img src="img/dtac.png" alt="" style="width:30%;height:auto;" /> -->
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="separator separator-bottom separator-skew zindex-100"
            ></div>
        </div>
        <!-- Page content -->
        <div class="container mt--8 pb-5">
            <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6">
                    <div class="card bg-secondary border-0 mb-0">
                        <div class="card-body">
                            <img src="img/logo.png" />
                            <div class="text-center text-muted mb-4">
                                <br />
                                {{ appName }}
                                <br />
                                <small>{{ $t("auth.signin") }}</small>
                            </div>
                            <validation-observer
                                v-slot="{ handleSubmit }"
                                ref="formValidator"
                            >
                                <form
                                    role="form"
                                    @submit.prevent="handleSubmit(onSubmit)"
                                >
                                    <base-input
                                        alternative
                                        class="mb-3"
                                        name="Email"
                                        error="error"
                                        prepend-icon="ni ni-email-83"
                                        :placeholder="$t('auth.username')"
                                        v-model="model.email"
                                        autocomplete="off"
                                    >
                                    </base-input>

                                    <base-input
                                        alternative
                                        class="mb-3"
                                        name="Password"
                                        prepend-icon="ni ni-lock-circle-open"
                                        type="password"
                                        :placeholder="$t('auth.password')"
                                        v-model="model.password"
                                        autocomplete="off"
                                    >
                                    </base-input>

                                    <div class="text-center">
                                        <base-button
                                            type="primary"
                                            native-type="submit"
                                            class="my-4 btn-info"
                                            >{{
                                                $t("auth.signin")
                                            }}</base-button
                                        >
                                        <base-button
                                            type="default"
                                            native-type="button"
                                            class="my-4 btn-info"
                                            >{{
                                                $t("auth.forgetpassword")
                                            }}</base-button
                                        >
                                    </div>

                                    <!-- <div
                                        class="divider d-flex align-items-center my-4"
                                    >
                                        <p
                                            class="text-center fw-bold mx-3 mb-0 text-muted"
                                        >
                                            OR
                                        </p>
                                    </div>

                                    <div class="row">
                                        <div class="col-6">
                                            <a
                                                class="btn btn-primary btn-lg btn-block"
                                                style="background-color: #3b5998"
                                                href="#!"
                                                role="button"
                                            >
                                                <i
                                                    class="fab fa-facebook-f me-2"
                                                ></i>
                                                Facebook
                                            </a>
                                        </div>

                                        <div class="col-6">
                                            <a
                                                class="btn btn-primary btn-lg btn-block"
                                                style="background-color: #06c755"
                                                href="#!"
                                                role="button"
                                            >
                                                Line</a
                                            >
                                        </div>
                                    </div> -->
                                </form>
                            </validation-observer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VueI18n from "vue-i18n";
import { mapActions, mapGetters, matGetters } from "vuex";
import swal from "sweetalert2";
const qs = require("querystring");

console.log(process.env.VUE_APP_RECAPTCHA);

export default {
    data() {
        return {
            appName: process.env.VUE_APP_TITLE,
            appVersion: process.env.VUE_APP_VERSION,
            recaptchaKey: process.env.VUE_APP_RECAPTCHA,
            model: {
                email: process.env.VUE_APP_USER,
                password: process.env.VUE_APP_PASSWORD,
                // email: "admin@asr.dev",
                // password: "P@ssw0rd",
                rememberMe: false
            },
            user: "agent",
            token: ""
        };
    },
    computed: {
        ...mapGetters({
            getUser: "Auth/getUser",
      getLocale: "Auth/getLocale"
        })
    },
    async mounted() {
		this.$i18n.locale = this.getLocale;
        await this.$recaptchaLoaded();
        this.$recaptchaInstance.showBadge();
    },
    methods: {
        ...mapActions({
            setUser: "Auth/setUser",
      setLocale: "Auth/setLocale",
            SignIn: "Auth/SignIn",
        }),
        en() {
      this.$i18n.locale = "en";
	  this.setLocale("en");
    },
    th() {
      this.$i18n.locale = "th";
	  this.setLocale("th");
    },
        async onSubmit() {
            this.token = await this.$recaptcha("login");
            this.SignIn({
                username: this.model.email,
                password: this.model.password,
                token: this.token
            })
                .then(res => {
					console.log(res)
                        this.$cookie.set("token", res.data.Token, {
                            expires: "1D"
                        });
                        this.setUser(res.data.User);
						this.$recaptchaInstance.hideBadge();
                        this.$router.push("/");
				})
                .catch(err => {
					console.log(err)
                    swal.fire({
                        title: this.$t(err.response.data.msg),
                        text: ``,
                        size: `sm`,
                        icon: "error",
                        confirmButtonClass: "btn btn-danger btn-fill",
                        buttonsStyling: false
                    });
                });
        }
    }
};
</script>

<style scoped>
.menu-locale {
    padding-top: 0.25in;
}

.divider:after,
.divider:before {
    content: "";
    flex: 1;
    height: 1px;
    background: #eee;
}
</style>
